import { PublicClientApplication, AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { loadConfig, IDENTITY_MANAGER_CONFIG } from "./config";
// MSAL Instance
loadConfig();
const cfg = IDENTITY_MANAGER_CONFIG();
console.log("Auth Config:", cfg);
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: cfg.client_id,
    authority: cfg.authority,
    knownAuthorities: cfg.knownAuthorities,       //trust your custom domain
    //cloudDiscoveryMetadata: cfg.cloudDiscoveryMetadata, //prevent lookup
    //authorityMetadata: cfg.authorityMetadata,     //prevent endpoint discovery
    redirectUri: cfg.redirect_uri,
    postLogoutRedirectUri: cfg.post_logout_redirect_uri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
});

// Login
export const login = async () => {
    console.log("login called");
  await msalInstance.loginRedirect({
    scopes: cfg.scope.split(" "),
  });
};

// Logout
export const logout = async () => {
  await msalInstance.logoutRedirect();
};

// Acquire token silently or redirect
export const acquireAccessToken = async (): Promise<string | null> => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;

  try {
    const result: AuthenticationResult = await msalInstance.acquireTokenSilent({
      account: accounts[0],
      scopes: cfg.scope.split(" "),
    });
    return result.accessToken;
  } catch {
    await msalInstance.acquireTokenRedirect({ scopes: cfg.scope.split(" ") });
    return null;
  }
};

// Return current account
export const getAccount = (): AccountInfo | null => {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length > 0 ? accounts[0] : null;
};
